import { Component } from '@angular/core';

@Component({
  templateUrl: './change-password.page.html',
})
/**
 * Change password page!
 */
export class ChangePasswordPage {}
